// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dicom-uploader .button {\r\n  float: left;\r\n  margin: 5px;\r\n}\r\n\r\n.invisible-input {\r\n  position: absolute;\r\n  display: none;\r\n  z-index: -1000;\r\n  max-width: 0 !important;\r\n  max-height: 0 !important;\r\n}\r\n\r\n.dicom-uploader .table-header {\r\n  color: #ffffff;\r\n  font-size: 16px;\r\n  font-weight: 28px;\r\n  text-align: left;\r\n  margin: 20px auto;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
